import classNames from 'classnames';
import React from 'react';
import { ListIcon, MapIcon } from '../Icons';

interface Props {
  mapView: boolean;
  setMapView: any;
  labels: {
    list: string;
    map: string;
  };
}

export const ListMapToggle = ({ mapView, setMapView, labels }: Props) => {
  return (
    <div className='list-view-toggle d-block'>
      <div className='view-toggle d-flex border border-radius-4 align-items-center'>
        <div
          className={classNames('cursor-pointer border-end px-4 py-3 font-16 font-bold', {
            'text-dark bg-grey-light svg-stroke-grey': !mapView,
            'text-red bg-transparent svg-stroke-red': mapView,
          })}
          onClick={() => {
            setMapView(false);
          }}
        >
          <ListIcon />
          <span className='ms-2'>{labels?.list}</span>
        </div>
        <div
          className={classNames('cursor-pointer px-4 py-3 font-16 font-bold align-items-center', {
            'text-dark bg-grey-light svg-stroke-grey': mapView,
            'text-red bg-transparent svg-stroke-red': !mapView,
          })}
          onClick={() => {
            setMapView(true);
          }}
        >
          <MapIcon />
          <span className='ms-2'>{labels?.map}</span>
        </div>
      </div>
    </div>
  );
};
